<template>
  <div class="rb-diamond-card">
    <div class="rb-top-wrap flex align-items-center justify-content-between">
      <div class="rb-diamond-sku">SKU {{ diamond.sku }}</div>
      <div class="rb-gia">
        <gia-certificate :diamond="diamond" />
      </div>
    </div>
    <diamond-data :diamond="diamond" />
    <div class="rb-diamond-pricing">
      <template v-if="combinePrice">
        <span>Diamond &amp; Setting</span>&nbsp;
        <span class="rb-diamond-price">{{
          (parseInt(diamond.retail_price) + parseInt(dataPrice.baseRingPrice))
            | money
        }}</span></template
      >
      <template v-else
        ><span>Diamond Price</span>&nbsp;
        <span class="rb-diamond-price">{{
          parseInt(diamond.retail_price) | money
        }}</span></template
      >
    </div>
    <custom-checkbox
      v-if="selectors"
      :label="true"
      :selected="isDiamondSelected(selectedOptions, diamond)"
      :diamond="diamond"
      @rb-selected="
        () => {
          onDiamondSelected(diamond);
        }
      "
      @rb-deselected="onDiamondDeselected"
    />
  </div>
</template>
<script>
/**
 * Diamond basic information
 *
 * @props
 * diamond: Object
 * selectors: Boolean
 * dataPrice: Object
 *
 * @implements
 * DiamondsMixin
 * ChildMixin
 * FormattersMixin
 * CommMixin
 * FavsMixin
 *
 * @emits
 * rb-step-complete
 * rb-step-incomplete
 */
import CommMixin from "@/mixins/CommMixin";
import CustomCheckbox from "@/components/CustomCheckbox";
import ChildMixin from "@/mixins/ChildMixin";
import DiamondsMixin from "@/mixins/DiamondsMixin";
import FormattersMixin from "@/mixins/FormattersMixin";
import GiaCertificate from "@/components/GiaCertificate";
import DiamondData from "@/components/DiamondData";
import FavsMixin from "@/mixins/FavsMixin";
export default {
  mixins: [DiamondsMixin, ChildMixin, FormattersMixin, CommMixin, FavsMixin],
  components: {
    CustomCheckbox,
    GiaCertificate,
    DiamondData,
  },
  props: {
    diamond: {
      type: Object,
    },
    selectors: {
      type: Boolean,
      default: true,
    },
    dataPrice: {
      type: Object,
    },
    combinePrice: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onDiamondSelected: function (diamond) {
      this.broadcast("rb-step-complete", { step: this.data, choice: diamond });
    },
    onDiamondDeselected: function () {
      this.broadcast("rb-step-incomplete", { step: this.data });
    },
  },
};
</script>
